export default __webpack_public_path__ + "static/977-8538a3406b74242ac261b3ee43fb8aee.gif";